import { useSelector } from 'react-redux'
import { Icon } from '../../../../../../common/html/icon'
import { Tooltip } from '../../../../../../common/tooltip'
import { formatVal } from '../../../../../../helpers/value'
import { CustomCell } from './CustomCell'

export const RowGroup = ({
  rowId,
  rowGroupIndex,
  schema,
  selectRowGroup,
  selectCellData,
  isDynamicReport,
}) => {
  const locale = useSelector((state) => state.i18n.locale)
  const rowGroup = useSelector(selectRowGroup(rowId))

  const getFormatVal = (colId, tooltipGroup) => (val) => {
    switch (colId) {
      case 'group':
        if (isDynamicReport) {
          return (
            <div>
              <span className="fw600">{val}</span>
            </div>
          )
        }
        if (tooltipGroup) {
          return (
            <div className="dFlex gap1 fw600">
              {val}
              <Tooltip isI18n={false} tooltipContent={tooltipGroup}>
                <Icon
                  className="icon-info-circle"
                  style={{ color: '#9C9C9C' }}
                />
              </Tooltip>
            </div>
          )
        }
        return (
          <div>
            <span className="fw600">{val}</span>
          </div>
        )
      case 'ratioName':
        return (
          <div>
            <span>{val}</span>
          </div>
        )

      default:
        return formatVal(val, locale)
    }
  }

  const renderContent = (rowIndex, tooltipGroup) => {
    return schema
      .slice(rowIndex === 0 ? 0 : 1)
      .map(({ colId, colCustomId }, colIndex) => {
        return (
          <CustomCell
            key={colIndex}
            rowSpan={colIndex === 0 && rowIndex === 0 ? rowGroup.length : 1}
            rowId={rowId}
            colIndex={colIndex}
            colId={colId}
            rowIndex={rowIndex}
            selectCellData={selectCellData}
            format={getFormatVal(colId, tooltipGroup)}
            colCustomId={colCustomId}
          />
        )
      })
  }

  const getBgColor = () => {
    if (isDynamicReport) {
      return rowGroupIndex % 2 === 0 ? '#F9F9F9' : '#FFFFFF'
    }

    return rowGroupIndex % 2 === 0 ? '#F9F9F9' : '#FFFFFF'
  }

  return rowGroup.map(({ tooltipGroup }, rowIndex) => {
    return (
      <tr
        key={rowIndex}
        style={{
          borderBottom: rowIndex === rowGroup.length - 1 && '1px solid #D5D5D5',
          backgroundColor: getBgColor(),
        }}
      >
        {renderContent(rowIndex, tooltipGroup)}
      </tr>
    )
  })
}
